var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.path.includes(this.$route.name))?_c('div',[_c('Float')],1):_vm._e(),_c('Rdialog',{attrs:{"isIntegral":_vm.isIntegral,"integralText":_vm.integralText},on:{"handleClose":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }